export * from './link';
export { createOperation, makePromise, toPromise, fromPromise, fromError, } from './linkUtils';
import Observable from 'zen-observable-ts';
export { Observable };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-link/lib/index.js
// module id = 227
// module chunks = 0